import { FormControl } from "@angular/forms";

export class SitFamModel {
    public enCouple: boolean = undefined;
    public nbEnfants: number = undefined;

    constructor() { }
    
    setEnCouple(val: boolean): void {
        this.enCouple = val;
    }
   
    getEnCouple(): boolean {
        return this.enCouple;
    }

    setNbEnfants(val: number): void {
        this.nbEnfants = val;
    }
   
    getNbEnfants(): number {
        return this.nbEnfants;
    }
}

export class SitFamForm {
    situationFamiliale?:FormControl<string>;
    nbEnfant:FormControl<string>;
}

export interface SitFamFormValue {
    situationFamiliale? : string;
    nbEnfant : string;
}
